require("../../shared_modules/base-layout");
require("../../shared_modules/sprites");

module.exports = {};

require('/var/lib/jenkins/workspace/pf-yts-ui_Release_0/src/shared_modules/contact-info/contact.less');